import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{#if @placeholder}}\n  <span class=\"ember-power-select-placeholder\" ...attributes>{{@placeholder}}</span>\n{{/if}}\n")